<template>
	<div class="content my-0 py-1">
		<div class="container-fluid">
			<div class="row">
				<!-- <div class="col-12  mt-4 py-0">
					<h4 class="m-0 p-0 text-secondary d-inline">{{ dicts.label_title[dicts.lang] }}</h4>
					<button class="float-right btn btn-primary shadow" v-on:click="formNewvessel=!formNewvessel"
					    v-if="['master_admin','admin','finance'].includes(role) && role !== 'root'">
						{{ dicts.label_tambah_kapal_baru[dicts.lang] }}
					</button>
				</div> -->
				
				<div class="col-12 mt-4 py-0">

					<h4 class="m-0 p-0 text-secondary d-inline">{{ dicts.label_title[dicts.lang] }}</h4>
				<div v-if="['master_admin', 'admin', 'finance'].includes(role) && role !== 'root'">
				<button class="float-right btn btn-primary shadow" @click="formNewvessel=!formNewvessel">
					{{ dicts.label_tambah_kapal_baru[dicts.lang] }}
				</button>
				</div>
				</div>
				<div class="col-12  mt-2 py-0">
					<create-vessel @createvessel="createVesselResult" :formstate="formNewvessel" :lang="dicts.lang"/>
				</div>
				<div class="col-12  my-2 py-0">
					<datatable :current-idx="currentPage"
					           :lang="dicts.lang" 
							   :datas="mastervessels" 
					           :structure="MastervesselTableStructure" 
							   :init="loadData" use-seeker
							   :next-url="nextUrl"
					           seeker-url="/api/master/seeker/vessel"
					           @refetch="(row)=>{rowLimit=row;getMastervessels()}" :prev-url="prevUrl"
					           @change-page="(isNext)=>{changePage(isNext)}"
					           @change-url="(url)=>getMastervessels(url+(url.includes('?')?'&':'?')+'limit='+rowLimit)"
					           @searching="(val)=>!val.status?getMastervessels():mastervessels=val.data">
						<template #customcell={obj,index}>
							<td v-if="!isMobile">{{ ((currentPage - 1) * perPage) + index + 1 }}</td>
							<td v-if="!isMobile">
								{{ obj.client ? obj.client.customer_id != null ? obj.client.customer_id : "-" : "-" }}
							</td>
							<td v-if="!isMobile">{{ obj.hardware_setup ? obj.hardware_setup.nbk : "-" }}</td>
							<td v-if="!isMobile">{{ obj.hardware_setup ? obj.hardware_setup.id_transmitter : "-" }}</td>
							<td v-if="!isMobile">{{ obj.hardware_setup ? obj.hardware_setup.serial_number.serial_number : "-" }}</td>
							<td v-if="!isMobile">{{ obj.jb ? obj.jb.serial_number : "-" }}	</td>
							<td v-if="!isMobile">
								{{ obj.client ? obj.client.legal_name != null ? obj.client.legal_name : "-" : "-" }}
							</td>
							<td v-if="!isMobile">{{ obj.name }}</td>
							<td v-if="!isMobile">{{ obj.gt }}</td>
							<td v-if="!isMobile">{{ obj.type_vessel ? obj.type_vessel : "-" }}</td>
							<td v-if="!isMobile">{{ obj.hardware_setup ? obj.hardware_setup.device_status_id : "-" }}</td>
							<td v-if="!isMobile">
							<b-dropdown
								id="dropdown-actions"
								variant="primary"
								class="mb-1 text-left"
								size="sm"
								right
								text="Actions"
								style="font-size: 15px; min-width: 180px;"
								>
								<b-dropdown-item
									v-if="['master_admin','admin'].includes(role) && role !== 'root'"
									v-b-modal.modal-detail-supervisor
									@click="selectedDetail = index; getVesselSupervisor()"
								>
									<b-icon icon="person-plus" class="mr-2" /> Supervisor
								</b-dropdown-item>

								<b-dropdown-item
									v-b-modal.modal-detail-vessel
									@click="selectedDetail = index"
								>
									<b-icon icon="eye" class="mr-2" /> Detail Vessel
								</b-dropdown-item>

								<b-dropdown-item
									v-b-modal.modal-map-vessel
									@click="selectedDetail = index; setPolygon(index)"
								>
									<b-icon icon="map" class="mr-2" /> Map Vessel
								</b-dropdown-item>

								<b-dropdown-item
								    v-if="['master_admin','admin'].includes(role)"
									v-b-modal.modal-edit-vessel
									@click="selectedIdforEdit = index; dataEdit = Object.assign({}, obj)"
								>
									<b-icon icon="pencil-square" class="mr-2" /> Edit Vessel
								</b-dropdown-item>

								<b-dropdown-item
									v-if="['master_admin','admin'].includes(role)"
									v-b-modal.modal-delete
									@click="deleteId = obj.id; itemToDelete = obj"
								>
									<b-icon icon="trash" class="mr-2" /> Delete
								</b-dropdown-item>
								</b-dropdown>

							</td>


							<td v-if="isMobile" class="py-3">
								<ul style="list-style:none;width:100%;padding:0" class="rounded shadow bg-white p-2">
									<li class="mt-2">
										<div class="text-left mx-3 pt-0">
											<small class="my-0 py-0">{{ dicts.label_nama_kapal[dicts.lang] }}:</small>
											<br><b class="py-0 mx-0" style="font-size:10pt">{{ obj.name }}</b>
										</div>
										<hr class="my-1">
									</li>
									<li>
										<div class="text-left mx-3">
											<small class="my-0 py-0">{{ dicts.label_idpemilik[dicts.lang] }}:</small>
											<br><b class="py-0 mx-0"
											       style="font-size:10pt">{{ obj.client ? obj.client.customer_id != null ? obj.client.customer_id : "-" : "-" }}</b>
										</div>
									</li>
									<li>
										<div class="text-left mx-3 pt-0">
											<small class="my-0 py-0">NBK:</small>
											<br><b class="py-0 mx-0"
											       style="font-size:10pt">{{ obj.hardware_setup ? obj.hardware_setup.nbk : "-" }}</b>
										</div>
									</li>
									<li>
										<div class="text-left mx-3 pt-0">
											<small class="my-0 py-0">ID transmitter:</small>
											<br><b class="py-0 mx-0"
											       style="font-size:10pt">{{ obj.hardware_setup ? obj.hardware_setup.id_transmitter : "-" }}</b>
										</div>
									</li>
									<li>
										<div class="text-left mx-3 pt-0">
											<small class="my-0 py-0">SERIAL NUMBER:</small>
											<br><b class="py-0 mx-0"
											       style="font-size:10pt">{{obj.serial_number?obj.serial_number.serial_number:'-'}}</b>
										</div>
									</li>
									<li>
										<div class="text-left mx-3 pt-0">
											<small class="my-0 py-0">NOMOR JB:</small>
											<br><b class="py-0 mx-0"
											       style="font-size:10pt">{{ obj.jb ? obj.jb.serial_number : "-" }}</b>
										</div>
									</li>
									<li>
										<div class="text-left mx-3">
											<small class="my-0 py-0">{{ dicts.label_pemilik[dicts.lang] }}:</small>
											<br><b class="py-0 mx-0"
											       style="font-size:10pt">{{ obj.client ? obj.client.legal_name != null ? obj.client.legal_name : "-" : "-" }}</b>
										</div>
									</li>
									<li>
										<div class="text-left mx-3">
											<small class="my-0 py-0">{{ dicts.label_tipe_kapal[dicts.lang] }}:</small>
											<br><b class="py-0 mx-0"
											       style="font-size:10pt">{{ obj.gt ? obj.gt : "-" }}</b>
										</div>
										<hr class="my-1">
									</li>
									<li>
										<div class="text-left mx-3">
											<small class="my-0 py-0">{{ dicts.label_tipe_kapal[dicts.lang] }}:</small>
											<br><b class="py-0 mx-0"
											       style="font-size:10pt">{{ obj.type_vessel ? obj.type_vessel : "-" }}</b>
										</div>
										<hr class="my-1">
									</li>
									<li>
										<div class="text-left mx-3 mt-2">
											<b-button v-b-modal.modal-detail-supervisor class="btn btn-success mr-2"
											          v-on:click="selectedDetail=index;getVesselSupervisor(index)">
												<b-icon icon="person-plus"></b-icon>
											</b-button>
											<b-button v-b-modal.modal-detail-vessel class="btn btn-primary mr-2"
											          v-on:click="selectedDetail=index">
												<b-icon icon="eye"></b-icon>
											</b-button>
											<b-button v-b-modal.modal-edit-vessel class="btn btn-info mr-2"
											          v-on:click="selectedIdforEdit=index">
												<b-icon icon="pencil-square"></b-icon>
											</b-button>
											<button v-b-modal.modal-delete v-on:click="deleteId=obj.id;itemToDelete=obj"
											        class="btn btn-danger">
												<b-icon icon="trash"></b-icon>
											</button>
										</div>
									</li>
								</ul>
							</td>
						</template>
					</datatable>
				</div>
			</div>
		</div>
		<!-- <b-modal no-close-on-esc  content-class="m-0"  id="modal-delete-vessel" title="Konfirmasi hapus vessel" scrollable no-close-on-backdrop @hide="deleteModalClose">
			<b-container fluid v-if="!loadData && mastervessels.length>0">
				<b-row class="pt-1">
				  <b-col cols="12" class="my-3">
					  <h4>Apakah yakin mau menghapus data dengan detail berikut:</h4>
					  <ul>
						  <li>vessel: {{mastervessels[selectedToDelete].name}}</li>
						  <li>tipe: {{mastervessels[selectedToDelete].type_vessel}}</li>
					  </ul>
				  </b-col>
				   <b-col cols="12" class="my-3 text-right"  v-if="deletevesselState">
					   <div class="d-flex align-items-center justify-content-start">
							<div class="spinner-border" role="status" aria-hidden="true"></div>
							<strong class=" ml-2">Menghapus data, tunggu sebentar.</strong>
						</div>
					</b-col>
					<div class="col-12 mt-3"  v-if="vesselDeleted">
						<div class="w-100 align-items-center justify-content-start">
							<div class="alert alert-success" role="alert">
								Berhasil menghapus data.
							</div>
						</div>
					</div>
					<div class="col-12 mt-3"  v-if="failDeletevessel">
						<div class="w-100 align-items-center justify-content-start">
							<div class="alert alert-danger" role="alert">
								Gagal menghapus data klien.
							</div>
						</div>
					</div>
				</b-row>
			</b-container>
			<template #modal-footer>
				<div class="w-100 text-right m-0 p-0">
				<hr>
				<button class="btn btn-danger  mr-2" v-on:click="deletevesselData">Ya, hapus</button>
				<b-button class="btn btn-secondary" @click="(!deletevesselState)?$bvModal.hide('modal-delete-vessel'):''">Tutup</b-button>
				</div>
			</template>
		</b-modal> -->

		<b-modal no-close-on-esc id="modal-detail-supervisor" scrollable no-close-on-backdrop
		         @hide="detailSupervisorModalClose" content-class="m-0">
			<b-container fluid>
				<b-row class="pt-1">
					<b-col cols="12">
						<table rules="rows" class="table w-100">
							<tbody>

							<tr>
								<th class="w-100 px-3 bg-secondary text-white" style="font-size:14pt" colspan="2"
								    scope="row">
									<div class="w-100 text-left">
										<span>List supervisor</span>
										<b-button v-b-modal.modal-detail-supervisor
										          class="btn btn-primary mr-2 bg-white float-right py-1 px-2"
										          v-on:click="addSupervisorMenu=!addSupervisorMenu">add
										</b-button>
									</div>
									<div class="w-100 text-left mt-3 bg-white shadow rounded text-dark"
									     v-show="addSupervisorMenu">
										<span class="mx-3">Add new supervisor</span><br>
										<div class="p-3">
											<smart-search direct :search-value="newsupervisorlabel"
											              @update-direct="(val)=>newsupervisorlabel=val" init
											              url="/api/master/seeker/getsupervisor" key-tag="name"
											              :label-tag="['name','username']"
											              v-on:update="(data)=>smartSearchAddSupervisor(data)"></smart-search>
										</div>
										<div class="px-3 w-100 align-items-center justify-content-start"
										     v-if="newSuperVisorState.success">
											<div class="alert alert-success" role="alert">
												Berhasil menyimpan data.
											</div>
										</div>
										<div class="px-3 w-100 align-items-center justify-content-start"
										     v-if="newSuperVisorState.error">
											<div class="alert alert-danger" role="alert">
												Gagal menyimpan data.
											</div>
										</div>
										<div class="px-3 w-100 align-items-center justify-content-start"
										     v-if="newSuperVisorState.creating">
											<div class="alert alert-secondary" role="alert">
												Menyimpan data, tunggu sebentar.
											</div>
										</div>
										<div class="p-3" v-if="!newSuperVisorState.creating">
											<b-button v-b-modal.modal-detail-supervisor
											          class="btn btn-primary w-100 bg-white"
											          v-on:click="addNewSupervisor()">submit
											</b-button>
										</div>
									</div>
								</th>
							</tr>
							<tr v-if="removeSuperVisorState.creating">
								<div class="mt-2 alert alert-secondary" role="alert">
									Menghapus, tunggu sebentar.
								</div>
							</tr>
							<tr v-if="removeSuperVisorState.error">
								<div class="mt-2 alert alert-danger text-dark" role="alert">
									Gagal menyimpan data.
								</div>
							</tr>
							<tr v-if="removeSuperVisorState.success">
								<div class="mt-2 alert alert-success" role="alert">
									Berhasill menyimpan data.
								</div>
							</tr>
							<tr v-for="(data) in vesselSupervisors" v-bind:key="'supervisorlist'+data.id"
							    v-show="!removeSuperVisorState.creating">
								<td class="text-left" colspan="2">
									<div class="px-2 w-100 d-block">
										<div class="d-inline">{{ data.supervisor.name }} -
											{{ data.supervisor.username }}
										</div>
										<div class="float-right">
											<button v-on:click="removeSupervisor(data.id)" class="btn btn-danger py-0">
												Hapus
											</button>
										</div>
									</div>
									<hr class="mt-3">
								</td>
							</tr>

							<tr v-if="vesselSupervisors.length<1&&!loadSupervisorData">
								<td class="" colspan="2">Tidak ada supervisor untuk vessel ini</td>
							</tr>
							<tr v-if="loadSupervisorData">
								<td class="" colspan="2">Tunggu sebentar</td>
							</tr>

							</tbody>
						</table>
					</b-col>

					<b-col cols="12" class="my-3 text-right" v-if="deletevesselState">
						<div class="d-flex align-items-center justify-content-start">
							<div class="spinner-border" role="status" aria-hidden="true"></div>
							<strong class=" ml-2">Menghapus data, tunggu sebentar.</strong>
						</div>
					</b-col>
					<div class="col-12 mt-3" v-if="vesselDeleted">
						<div class="w-100 align-items-center justify-content-start">
							<div class="alert alert-success" role="alert">
								Berhasil menghapus data klien.
							</div>
						</div>
					</div>
					<div class="col-12 mt-3" v-if="failDeletevessel">
						<div class="w-100 align-items-center justify-content-start">
							<div class="alert alert-danger" role="alert">
								Gagal menghapus data klien.
							</div>
						</div>
					</div>
				</b-row>
			</b-container>
			<template #modal-footer>
				<div class="w-100 text-right m-0 p-0">
					<hr>
					<!-- <button class="btn btn-danger mr-2" v-on:click="deletevesselData">Ya, hapus</button> -->
					<b-button class="btn btn-secondary"
					          @click="(!deletevesselState)?$bvModal.hide('modal-detail-supervisor'):''">Tutup
					</b-button>
				</div>
			</template>
		</b-modal>

		<b-modal no-close-on-esc content-class="m-0" id="modal-detail-vessel" scrollable no-close-on-backdrop
		         @hide="detailModalClose">
			<b-container fluid v-if="!loadData&&mastervessels.length>0">
				<b-row class="pt-1" v-if="mastervessels[selectedDetail]!=undefined">
					<b-col cols="12">
						<table v-if="mastervessels.length>0" rules="rows" class="table w-100">
							<tbody>
							<tr>
								<th class="w-100 px-3 bg-secondary text-white" style="font-size:14pt" colspan="2"
								    scope="row">Detail Kapal
								</th>
							</tr>
							<tr>
								<th class="" scope="row">ID transmitter</th>
								<td class="">
									{{ mastervessels[selectedDetail].hardware_setup != null ? mastervessels[selectedDetail].hardware_setup.id_transmitter : "-" }}
								</td>
							</tr>
							<tr>
								<th class="" scope="row">{{ dicts.label_nama_kapal[dicts.lang] }}</th>
								<td class="">
									{{ mastervessels[selectedDetail].name != null ? mastervessels[selectedDetail].name : "-" }}
								</td>

							</tr>
							<tr>
								<th class="" scope="row">{{ dicts.label_pemilik[dicts.lang] }}</th>
								<td class="">
									{{ mastervessels[selectedDetail].client ? mastervessels[selectedDetail].client.legal_name != null ? mastervessels[selectedDetail].client.legal_name : "-" : "-" }}
								</td>
							</tr>
							<tr>
								<th class="" scope="row">{{ dicts.label_idpemilik[dicts.lang] }}</th>
								<td class="">
									{{ mastervessels[selectedDetail].client ? mastervessels[selectedDetail].client.customer_id != null ? mastervessels[selectedDetail].client.customer_id : "-" : "-" }}
								</td>
							</tr>
							<tr>
								<th class="" scope="row">{{ dicts.label_tipe_kapal[dicts.lang] }}</th>
								<td class="">
									{{ mastervessels[selectedDetail].type_vessel != null ? mastervessels[selectedDetail].type_vessel : "-" }}
								</td>
							</tr>
							<tr>
								<th class="" scope="row">Radio</th>
								<td class="">
									{{ mastervessels[selectedDetail].radio != null ? mastervessels[selectedDetail].radio : "-" }}
								</td>
							</tr>
							<tr>
								<th class="" scope="row">GT</th>
								<td class="">
									{{ mastervessels[selectedDetail].gt != null ? mastervessels[selectedDetail].gt : "-" }}
								</td>
							</tr>
							<tr>
								<th class="" scope="row">Selar Sign</th>
								<td class="">
									{{ mastervessels[selectedDetail].selar_sign != null ? mastervessels[selectedDetail].selar_sign : "-" }}
								</td>
							</tr>
							<tr>
								<th class="" scope="row">{{ dicts.label_material[dicts.lang] }}</th>
								<td class="">
									{{ mastervessels[selectedDetail].material != null ? mastervessels[selectedDetail].material : "-" }}
								</td>
							</tr>
							<tr>
								<th class="" scope="row">{{ dicts.label_lebar[dicts.lang] }}</th>
								<td class="">
									{{ mastervessels[selectedDetail].lebar != null ? mastervessels[selectedDetail].lebar : "-" }}
								</td>
							</tr>
							<tr>
								<th class="" scope="row">{{ dicts.label_panjang[dicts.lang] }}</th>
								<td class="">
									{{ mastervessels[selectedDetail].panjang != null ? mastervessels[selectedDetail].panjang : "-" }}
								</td>
							</tr>
							<tr>
								<th class="" scope="row">{{ dicts.label_power_boat[dicts.lang] }}</th>
								<td class="">
									{{ mastervessels[selectedDetail].power_boat != null ? mastervessels[selectedDetail].power_boat : "-" }}
								</td>
							</tr>
							<tr>
								<th class="" scope="row">{{ dicts.label_merk_mesin[dicts.lang] }}</th>
								<td class="">
									{{ mastervessels[selectedDetail].merk_mesin != null ? mastervessels[selectedDetail].merk_mesin : "-" }}
								</td>
							</tr>
							<tr>
								<th class="" scope="row">{{ dicts.label_no_mesin[dicts.lang] }}</th>
								<td class="">
									{{ mastervessels[selectedDetail].no_mesin != null ? mastervessels[selectedDetail].no_mesin : "-" }}
								</td>
							</tr>
							<tr>
								<th class="" scope="row">Groos Deed</th>
								<td class="">
									{{ mastervessels[selectedDetail].gross_deed != null ? mastervessels[selectedDetail].gross_deed : "-" }}
								</td>
							</tr>
							<tr>
								<th class="" scope="row">{{ dicts.label_tahun_pembuatan[dicts.lang] }}</th>
								<td class="">
									{{ mastervessels[selectedDetail].tahun_pembuatan != null ? mastervessels[selectedDetail].tahun_pembuatan : "-" }}
								</td>
							</tr>
							<tr>
								<th class="" scope="row">{{ dicts.label_alamat_pembuatan[dicts.lang] }}</th>
								<td class="">
									{{ mastervessels[selectedDetail].alamat_pembuatan != null ? mastervessels[selectedDetail].alamat_pembuatan : "-" }}
								</td>
							</tr>
							<tr>
								<th class="" scope="row">No Sipi</th>
								<td class="">
									{{ mastervessels[selectedDetail].no_sipi != null ? mastervessels[selectedDetail].no_sipi : "-" }}
								</td>
							</tr>
							<tr>
								<th class="" scope="row">{{ dicts.label_flag[dicts.lang] }}</th>
								<td class="">
									{{ mastervessels[selectedDetail].flag != null ? mastervessels[selectedDetail].flag : "-" }}
								</td>
							</tr>
							<tr>
								<th class="" scope="row">{{ dicts.label_start_sipi[dicts.lang] }}</th>
								<td class="">
									{{ mastervessels[selectedDetail].start_sipi != null ? mastervessels[selectedDetail].start_sipi : "-" | timeformat }}
								</td>
							</tr>
							<tr>
								<th class="" scope="row">{{ dicts.label_end_sipi[dicts.lang] }}</th>
								<td class="">
									{{ mastervessels[selectedDetail].end_sipi != null ? mastervessels[selectedDetail].end_sipi : "-" | timeformat }}
								</td>
							</tr>
							<tr>
								<th class="" scope="row">No registrasi RMOF</th>
								<td class="">
									{{ mastervessels[selectedDetail].no_registrasi_rmof != null ? mastervessels[selectedDetail].no_registrasi_rmof : "-" }}
								</td>
							</tr>
							<tr>
								<th class="" scope="row">Status</th>
								<td class="">{{ translateStatus(mastervessels[selectedDetail].status) }}</td>
							</tr>
							<tr>
								<th class="" scope="row">{{ dicts.label_user_update[dicts.lang] }}</th>
								<td class="">{{ mastervessels[selectedDetail].user_update }}</td>
							</tr>
							</tbody>
							<!-- <tr>
								<th class="" colspan="5">Hardware</th>
							</tr>
							<tr>
								<td class=""  colspan="5">

									<b-container fluid v-for="meta in mastervessels[selectedDetail].metadata" :key="meta" class="p-3 shadow-sm">
											<b-row>
												<b-col class=" mb-3" cols="12"><div class="rounded w-100 px-3 bg-secondary text-white"><b style="font-size:14pt">{{meta.hardware.hardware_name}}</b></div></b-col>
											</b-row>
											<b-row>
												<b-col class="px-3"><b>Quantity</b></b-col>
												<b-col class="px-3"><b>Harga</b></b-col>
												<b-col class="px-3"><b>Total</b></b-col>
											</b-row>
											<b-row>

												<b-col class="px-3">{{meta.qty}}</b-col>
												<b-col class="px-3">{{meta.unit_price}}</b-col>
												<b-col class="px-3">{{meta.amount}}</b-col>
											</b-row>


									</b-container>
								</td>
							</tr> -->


						</table>
					</b-col>

					<b-col cols="12" class="my-3 text-right" v-if="deletevesselState">
						<div class="d-flex align-items-center justify-content-start">
							<div class="spinner-border" role="status" aria-hidden="true"></div>
							<strong class=" ml-2">Menghapus data, tunggu sebentar.</strong>
						</div>
					</b-col>
					<div class="col-12 mt-3" v-if="vesselDeleted">
						<div class="w-100 align-items-center justify-content-start">
							<div class="alert alert-success" role="alert">
								Berhasil menghapus data klien.
							</div>
						</div>
					</div>
					<div class="col-12 mt-3" v-if="failDeletevessel">
						<div class="w-100 align-items-center justify-content-start">
							<div class="alert alert-danger" role="alert">
								Gagal menghapus data klien.
							</div>
						</div>
					</div>
				</b-row>
			</b-container>
			<template #modal-footer>
				<div class="w-100 text-right m-0 p-0">
					<hr>
					<!-- <button class="btn btn-danger mr-2" v-on:click="deletevesselData">Ya, hapus</button> -->
					<b-button class="btn btn-secondary"
					          @click="(!deletevesselState)?$bvModal.hide('modal-detail-vessel'):''">Tutup
					</b-button>
				</div>
			</template>
		</b-modal>

		<b-modal no-close-on-esc content-class="m-0" id="modal-edit-vessel" title="Edit data" scrollable
		         no-close-on-backdrop size="lg" @hide="editModalClose">
			<b-container>
				<b-row class="mt-3 pt-1" v-if="mastervessels[selectedIdforEdit]!=undefined">
					<div class="col-12 col-md-6 col-lg-4 mt-2">
						<label class="d-block">{{ dicts.label_nama_kapal[dicts.lang] }}</label>
						<input type="text" class="form-control w-100 rounded"
						       v-model="mastervessels[selectedIdforEdit].name"/>
					</div>
					<div class="col-12 col-md-6 col-lg-4 mt-2">
						<label class="d-block">{{ dicts.label_legal[dicts.lang] }}</label>
						<input type="text" class="form-control w-100 rounded"
						       v-model="mastervessels[selectedIdforEdit].name_legal"/>
					</div>
					<div class="col-12 col-md-6 col-lg-4 mt-2">
						<label class="d-block">{{ dicts.label_pemilik[dicts.lang] }}</label>
						<smart-search init url="/api/master/seeker/pengguna" :usedefault="true"
						              :default-value="mastervessels[selectedIdforEdit].client?mastervessels[selectedIdforEdit].client.legal_name!=null?mastervessels[selectedIdforEdit].client.legal_name:'Pilih Pelanggan':'Pilih Pelanggan'"
						              key-tag="legal_name" :label-tag="['customer_id','legal_name']"
						              v-on:update="(data)=>smartSearchUpdatedClient(data)"></smart-search>
					</div>
					<div class="col-12 col-md-6 col-lg-4 mt-2">
						<label class="d-block">{{ dicts.label_tipe_kapal[dicts.lang] }}</label>
						<input type="text" class="form-control w-100 rounded"
						       v-model="mastervessels[selectedIdforEdit].type_vessel"/>
					</div>
					<div class="col-12 col-md-6 col-lg-4 mt-2">
						<label class="d-block">Radio</label>
						<input type="text" class="form-control w-100 rounded"
						       v-model="mastervessels[selectedIdforEdit].radio"/>
					</div>
					<div class="col-12 col-md-6 col-lg-4 mt-2">
						<label class="d-block">GT</label>
						<input type="text" class="form-control w-100 rounded"
						       v-model="mastervessels[selectedIdforEdit].gt"/>
					</div>
					<div class="col-12 col-md-6 col-lg-4 mt-2">
						<label class="d-block">Selar Sign</label>
						<input type="text" class="form-control w-100 rounded"
						       v-model="mastervessels[selectedIdforEdit].selar_sign"/>
					</div>
					<div class="col-12 col-md-6 col-lg-4 mt-2">
						<label class="d-block">{{ dicts.label_material[dicts.lang] }}</label>
						<input type="text" class="form-control w-100 rounded"
						       v-model="mastervessels[selectedIdforEdit].material"/>
					</div>
					<div class="col-12 col-md-6 col-lg-4 mt-2">
						<label class="d-block">{{ dicts.label_panjang[dicts.lang] }}</label>
						<input type="number" class="form-control w-100 rounded"
						       v-model="mastervessels[selectedIdforEdit].panjang"/>
					</div>
					<div class="col-12 col-md-6 col-lg-4 mt-2">
						<label class="d-block">{{ dicts.label_lebar[dicts.lang] }}</label>
						<input type="number" class="form-control w-100 rounded"
						       v-model="mastervessels[selectedIdforEdit].lebar"/>
					</div>
					<div class="col-12 col-md-6 col-lg-4 mt-2">
						<label class="d-block">{{ dicts.label_power_boat[dicts.lang] }}</label>
						<input type="text" class="form-control w-100 rounded"
						       v-model="mastervessels[selectedIdforEdit].power_boat"/>
					</div>
					<div class="col-12 col-md-6 col-lg-4 mt-2">
						<label class="d-block">{{ dicts.label_merk_mesin[dicts.lang] }}</label>
						<input type="text" class="form-control w-100 rounded"
						       v-model="mastervessels[selectedIdforEdit].merk_mesin"/>
					</div>
					<div class="col-12 col-md-6 col-lg-4 mt-2">
						<label class="d-block">{{ dicts.label_no_mesin[dicts.lang] }}</label>
						<input type="text" class="form-control w-100 rounded"
						       v-model="mastervessels[selectedIdforEdit].no_mesin"/>
					</div>
					<div class="col-12 col-md-6 col-lg-4 mt-2">
						<label class="d-block">Groos Deed</label>
						<input type="text" class="form-control w-100 rounded"
						       v-model="mastervessels[selectedIdforEdit].gross_deed"/>
					</div>
					<div class="col-12 col-md-6 col-lg-4 mt-2">
						<label class="d-block">{{ dicts.label_tahun_pembuatan[dicts.lang] }}</label>
						<input type="number" class="form-control w-100 rounded"
						       v-model="mastervessels[selectedIdforEdit].tahun_pembuatan"/>
					</div>
					<div class="col-12 col-md-6 col-lg-4 mt-2">
						<label class="d-block">{{ dicts.label_alamat_pembuatan[dicts.lang] }}</label>
						<input type="text" class="form-control w-100 rounded"
						       v-model="mastervessels[selectedIdforEdit].alamat_pembuatan"/>
					</div>
					<div class="col-12 col-md-6 col-lg-4 mt-2">
						<label class="d-block">No Sipi</label>
						<input type="text" class="form-control w-100 rounded"
						       v-model="mastervessels[selectedIdforEdit].no_sipi"/>
					</div>
					<div class="col-12 col-md-6 col-lg-4 mt-2">
						<label class="d-block">{{ dicts.label_flag[dicts.lang] }}</label>
						<input type="text" class="form-control w-100 rounded"
						       v-model="mastervessels[selectedIdforEdit].flag"/>
					</div>
					<div class="col-12 col-md-6 col-lg-4 mt-2">
						<label class="d-block">{{ dicts.label_start_sipi[dicts.lang] }}</label>
						<b-form-datepicker today-button reset-button close-button :date-format-options="{day: 'numeric', month: 'short', year: 'numeric'}"
						                   id="datepicker-start-sipi"
						                   v-model="mastervessels[selectedIdforEdit].start_sipi" class="mb-2">
							{{ mastervessels[selectedIdforEdit].start_sipi }}
						</b-form-datepicker>
					</div>
					<div class="col-12 col-md-6 col-lg-4 mt-2">
						<label class="d-block">{{ dicts.label_end_sipi[dicts.lang] }}</label>
						<b-form-datepicker today-button reset-button close-button :date-format-options="{day: 'numeric', month: 'short', year: 'numeric'}"
						                   id="datepicker-end-sipi" v-model="mastervessels[selectedIdforEdit].end_sipi"
						                   class="mb-2">{{ mastervessels[selectedIdforEdit].end_sipi }}
						</b-form-datepicker>
					</div>
					<div class="col-12 col-md-6 col-lg-4 mt-2">
						<label class="d-block">No Registrasi RMOF</label>
						<input type="text" class="form-control w-100 rounded"
						       v-model="mastervessels[selectedIdforEdit].no_registrasi_rmof"/>
					</div>
					<div class="col-12 col-md-6 col-lg-4 mt-2">
						<label class="d-block">Status</label>
						<!-- <input type="text"  class="form-control w-100 rounded" v-model="mastervessels[selectedIdforEdit].status" /> -->
						<smart-select name="status" :options="statusTypeOptions"
						              v-on:update="(value)=>{mastervessels[selectedIdforEdit].status=value}"></smart-select>
					</div>
					<div class="col-12 col-md-6 col-lg-4 mt-2">
						<label class="d-block">{{ dicts.label_user_update[dicts.lang] }}</label>
						<input type="text" class="form-control w-100 rounded"
						       v-model="mastervessels[selectedIdforEdit].user_update" readonly/>
					</div>

					<b-col cols="12" class="my-3 text-right" v-if="updating">
						<div class="d-flex align-items-center justify-content-start">
							<div class="spinner-border" role="status" aria-hidden="true"></div>
							<strong class=" ml-2">Menyimpan Data, Tunggu Sebentar.</strong>
						</div>
					</b-col>
					<div class="col-12 mt-3" v-if="updateSaved">
						<div class="w-100 align-items-center justify-content-start">
							<div class="alert alert-success" role="alert">
								Berhasil Update Data List Kapal.
							</div>
						</div>
					</div>
					<div class="col-12 mt-3" v-if="errorUpdate">
						<div class="w-100 align-items-center justify-content-start">
							<div class="alert alert-danger" role="alert">
								Gagal Update Data List Kapal.
							</div>
						</div>
					</div>
				</b-row>
			</b-container>
			<template #modal-footer>
				<div class="w-100 text-right m-0 p-0">
					<hr>
					<button class="btn btn-info mr-2" v-on:click="updatevesselData">Submit</button>
					<b-button class="btn btn-secondary mr-2"
					          @click="(!editvesselState&&!updating)?$bvModal.hide('modal-edit-vessel'):''">Tutup
					</b-button>
				</div>
			</template>
		</b-modal>


		<b-modal no-close-on-esc content-class="m-0" id="modal-map-vessel" title="Edit data" scrollable
		         no-close-on-backdrop size="lg">
			<b-container>
		        <l-map
		        v-if="showMap"
		        :zoom="zoom"
		        :center="center"
		        :options="mapOptions"
		        style="height: 400px;width;100%"
		        @update:center="centerUpdate"
		        @update:zoom="zoomUpdate"
		        @click="addMarker"
		        ref="map"
		        >
		        <l-tile-layer
		        :url="url"
		        :attribution="attribution"
		        />
		        <l-polygon
				  :latLngs="coordinatesMaps"
				  fillPattern="IMAGE"
				  imageScale="X"
				/>
      			</l-map>
				<div class="col-12 mt-3" v-if="updateSaved">
					<div class="w-100 align-items-center justify-content-start">
						<div class="alert alert-success" role="alert">
							Berhasil Update Data Maps Track Kapal.
						</div>
					</div>
				</div>
				<div class="col-12 mt-3" v-if="errorUpdate">
					<div class="w-100 align-items-center justify-content-start">
						<div class="alert alert-danger" role="alert">
							Gagal Update Data Maps Track Kapal.
						</div>
					</div>
				</div>
			</b-container>
			<template #modal-footer>
				<div class="w-100 text-right m-0 p-0">
					<hr>
					<button class="btn btn-info mr-2" v-on:click="updatevesselMapsData">Submit</button>
					<button class="btn btn-danger mr-2" v-on:click="clearPolygon()">Clear Polygon</button>
					<b-button class="btn btn-secondary mr-2"
					          @click="(!editvesselState&&!updating)?$bvModal.hide('modal-map-vessel'):''">Tutup
					</b-button>
				</div>
			</template>
		</b-modal>
		<modal-delete url="/api/master/vessel/" @read="()=>{console.log('modal ready')}" @result="deleteResult"
		              :targetid="deleteId">
			Yakin mau menghapus data dengan detail berikut :<br>
			<ul>
				<li>Nama Kapal: {{ itemToDelete.name }}</li>
				<li>Nama Legal : {{ itemToDelete.name_legal }}</li>
			</ul>
		</modal-delete>
	</div>
</template>
<script>
//   import ChartCard from 'src/components/Cards/ChartCard.vue'
//   import StatsCard from 'src/components/Cards/StatsCard.vue'
//   import LTable from 'src/components/Table.vue'
import {EventBus} from "../../eventbus";
import * as axios from "axios";
import { latLng } from "leaflet";
import { LMap, LTileLayer, LMarker, LPopup, LTooltip, LPolygon } from "vue2-leaflet";
import { Icon } from 'leaflet';
import Datatable from "../../components/Datatable.vue";
import CreateVessel from "../../components/CreateVessel.vue";
import SmartSelect from "../../components/SmartSelect.vue";
import ModalDelete from "../../components/ModalDelete.vue";
import SmartSearch from "../../components/SmartSearch.vue";

export default {
	components: {
	    LMap,
	    LTileLayer,
	    LMarker,
	    LPopup,
	    LTooltip,
	    LPolygon,
		//   LTable,
		//   ChartCard,
		//   StatsCard
		"datatable": Datatable,
		"smart-select": SmartSelect,
		"smart-search": SmartSearch,
		"create-vessel": CreateVessel,
		"modal-delete": ModalDelete
	},
	data() {
		return {
			currentPage: 1,
			perPage: null,
			isMobile: false,
			loadSupervisorData: false,
			rowLimit: 10,
			rowVesselSupervisorLimit: 50,
			prevUrl: null,
			nextUrl: null,
			prevSupervisorUrl: null,
			nextSupervisorUrl: null,
			newsupervisorlabel: "",
			role: "",
			datatable: {
				loadData: false
			},
			itemTypeOptions: [
				{label: "Antena", value: "antena"},
				{label: "JB", value: "jb"}
			],
			statusTypeOptions: [
				{label: "Aktif", value: "active"},
				{label: "Tidak aktif", value: "inactive"}
			],
	      	zoom: 6,
			center: latLng(-6.200000, 106.816666),
  			mapOptions: {
	        		zoomSnap: 0.5
	      	},
		    url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
		    attribution:
		      '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
	      	showMap: true,
	      	coordinatesMaps: [],
			newSupervisor: {},
			newSuperVisorState: {
				creating: false,
				error: false,
				success: false
			},
			removeSuperVisorState: {
				creating: false,
				error: false,
				success: false
			},
			dataEdit: null,
			addSupervisorMenu: false,
			itemToDelete: {},
			deleteId: 0,
			errorvesselSaved: false,
			updatevesselSaved: false,
			editvesselState: false,
			deletevesselState: false,
			failDeletevessel: false,
			vesselDeleted: false,
			mastervessels: [],
			vesselSupervisors: [],
			errorNewvesselList: [],
			formNewvessel: false,
			errorNewvessel: false,
			savingNewvessel: false,
			newvesselSaved: false,
			searchValue: "",
			selectedToDelete: 0,
			selectedIdforEdit: 0,
			selectedDetail: 0,
			updating: false,
			errorUpdate: false,
			updateSaved: false,
			updatingListKapal: false,
			MastervesselTableStructure: [
				{
					label: "No",
					key: null
				},
				{
					label: {
						id: "CID",
						en: "CID"
					},
					key: null
				},
				{
					label: {
						id: "NBK",
						en: "NBK"
					},
					key: null
				},
				{	label: "SPKP ID / IMO", 
				    key: null
				},
				{
					label: {
						id: "SERIAL NUMBER",
						en: "SERIAL NUMBER"
					},
					key: null
				},
				{
					label: {
						id: "NOMER JB",
						en: "JB NUMBER"
					},
					key: null
				},
				{
					label: {
						id: "CUSTOMER",
						en: "CUSTOMER"
					},
					key: null
				},
				{
					label: {
						id: "NAMA KAPAL",
						en: "VASSEL NAMAE"
					},
					key: null
				},
				
				{
					label: {
						id: "GT",
						en: "GT"
					},
					key: null
				},
				{
					label: {
						id: "TIPE KAPAL",
						en: "VASSEL TYPE"
					},
					key: null
				},
				{
					label: {
						id: "DEVICE STATUS",
						en: "DEVICE STATUS"
					},
					key: null
				},
				{
					label: {
						id: "TINDAKAN",
						en: "ACTION"
					},
					key: null
				}
			],
			updateStatusTypeOptions: [
				{label: "Ya", value: "yes"},
				{label: "Tidak", value: "no"}
			],
			dicts: {
				lang: "id",
				label_title: {
					id: "Daftar kapal",
					en: "List vessel"
				},
				label_tambah_kapal_baru: {
					id: "TAMBAH",
					en: "ADD NEW"
				},
				label_tindakan: {
					id: "Tindakan",
					en: "Action"
				},
				label_nama_kapal: {
					id: "Nama kapal",
					en: "Vessel name"
				},
				label_legal: {
					id: "Nama legal kapal",
					en: "Vessel name legal"
				},
				label_pemilik: {
					id: "Pemilik",
					en: "Client"
				},
				label_idpemilik: {
					id: "ID Pemilik",
					en: "ID Client"
				},
				label_tipe_kapal: {
					id: "Tipe kapal",
					en: "Vessel type"
				},
				label_material: {
					id: "Bahan",
					en: "Material"
				},
				label_panjang: {
					id: "Panjang",
					en: "Lenght"
				},
				label_lebar: {
					id: "Lebar",
					en: "Width"
				},
				label_power_boat: {
					id: "Perahu motor",
					en: "Power boat"
				},
				label_merk_mesin: {
					id: "Merk mesin",
					en: "Machine brand"
				},
				label_no_mesin: {
					id: "No mesin",
					en: "Engine no"
				},
				label_tahun_pembuatan: {
					id: "Tahun pembuatan",
					en: "Production year"
				},
				label_alamat_pembuatan: {
					id: "Alamat pembuatan",
					en: "Production address"
				},
				label_flag: {
					id: "Negara",
					en: "Flag"
				},
				label_start_sipi: {
					id: "Mulai sipi",
					en: "Start sipi"
				},
				label_end_sipi: {
					id: "Selesai sipi",
					en: "End sipi"
				},
				label_user_update: {
					id: "Pembaruan pengguna",
					en: "User update"
				}
			}
		};
		
	},
	created() {
		console.clear();
		this.$reActivateAccess(this);
		console.log("list kapal page");
		this.getMastervessels();
		this.isMobile = this.$isMobile;
		window.addEventListener("resize", () => {
			console.log("screen update");
			this.isMobile = screen.width < 768;
		});
		this.dicts.lang = localStorage.getItem("lang");
		EventBus.$on("lang", () => {
			this.dicts.lang = localStorage.getItem("lang");
		});
		this.role = localStorage.getItem("role");
	},
	methods: {
		clearPolygon(){
	      	this.coordinatesMaps = [];
		},
		setPolygon(idx){
			var latTracking = this.mastervessels[this.selectedToDelete].track == null?[]:JSON.parse(this.mastervessels[this.selectedToDelete].track);
			var trackings = [];
			latTracking.forEach((v)=>{
				trackings.push(v);
			});
			this.coordinatesMaps = trackings;
			// this.coordinatesMaps = latTracking;
			console.log(trackings);
			var thos = this;
			setTimeout(function() {
      			thos.$refs.map.mapObject.invalidateSize()
		  	}, 500);
		},
	    addMarker(event) {
	      	this.coordinatesMaps.push(event.latlng);
	    },
		zoomUpdate(zoom) {
      		this.currentZoom = zoom;
    	},
    	centerUpdate(center) {
      		this.currentCenter = center;
    	},
		detailSupervisorModalClose(mdl) {
			if (this.loadSupervisorData || this.newSuperVisorState.creating) {
				mdl.preventDefault();
				return;
			}
			this.vesselSupervisors = [];
			this.newSupervisor = {};
			this.newsupervisorlabel = "";
			this.$forceUpdate();
		},
		smartSearchAddSupervisor(data) {
			this.newSupervisor.supervisor_id = data.id;
			this.newSupervisor.vessel_id = this.mastervessels[this.selectedDetail].id;
		},
		translateStatus(status) {
			var label = "";
			switch (status) {
				case "active":
					label = "Aktif";
					break;
				case "inactive":
					label = "Tidak Aktif";
					break;
			}
			return label;
		},
		smartSearchUpdatedClient(data) {
			console.clear();
			//console.log(data)
			//console.log("current client id:" + this.mastervessels[this.selectedIdforEdit].client_id)
			this.mastervessels[this.selectedIdforEdit].client_id = data.id;
			//console.log("new client id:" + this.mastervessels[this.selectedIdforEdit].client_id)
		},
		deleteResult(deleted) {
			console.log(deleted);
			if (deleted) {
				this.getMastervessels();
			}
		},
		createVesselResult(data) {
			console.log("create vessel finished");
			if (data.status) {
				this.getMastervessels();
				//this.resetNewVesselData();
			}
		},
		changePage(isNext) {
			let url = (isNext ? this.nextUrl : this.prevUrl);
			let params = (new URL(url).searchParams);
			const myParams = params.get("page");
			const newUrl = this.$baseUrl + "/api/master/vessel?limit=" + this.rowLimit + "&page=" + myParams;

			this.currentPage = myParams;
			this.getMastervessels(newUrl);
		},
		getVesselSupervisor(url = (this.$baseUrl + "/api/master/seeker/supervisor-list-for-vessel/" + this.mastervessels[this.selectedDetail].id + "?limit=" + this.rowVesselSupervisorLimit)) {
			//this.loadData=true;
			this.vesselSupervisors = [];
			this.loadSupervisorData = true;
			this.$forceUpdate();
			axios.get(url, {
				"headers": {
					"Authorization": "Bearer " + localStorage.getItem("accessToken")
				}
			}).then((result) => {
				console.log(result);
				this.loadSupervisorData = false;
				this.prevSupervisorUrl = result.data.prev_page_url;
				this.nextSupervisorUrl = result.data.next_page_url;
				this.vesselSupervisors = result.data.data;
			}).catch((err) => {
				//check if token fail
				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}
				console.log(err);
				this.loadData = false;
			});
		},
		getMastervessels(url = (this.$baseUrl + "/api/master/vessel?limit=" + this.rowLimit)) {
			this.loadData = true;
			this.$forceUpdate();
			axios.get(url, {
				"headers": {
					"Authorization": "Bearer " + localStorage.getItem("accessToken")
				}
			}).then((result) => {
				console.log(result);
				this.loadData = false;
				this.prevUrl = result.data.prev_page_url;
				this.nextUrl = result.data.next_page_url;
				this.currentPage = result.data.current_page;
				this.perPage = parseInt(result.data.per_page);
				this.mastervessels = result.data.data;
				this.$forceUpdate();
			}).catch((err) => {
				//check if token fail
				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}
				console.log(err);
				this.loadData = false;
			});
		},
		
		removeSupervisor(id) {
			console.log("deleting data");
			this.removeSuperVisorState.creating = true;
			axios.delete(this.$baseUrl + "/api/master/vessel-supervisor/" + id, {
				"headers": {
					"Authorization": "Bearer " + localStorage.getItem("accessToken")
				}
			}).then((result) => {
				this.removeSuperVisorState.creating = false;
				if (result.status == 200) {
					this.removeSuperVisorState.success = true;

					setTimeout(() => {
						this.getVesselSupervisor();
						this.removeSuperVisorState.success = false;
					}, 1000);
				} else {
					this.removeSuperVisorState.error = true;
				}
			}).catch((err) => {
				//check if token fail
				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}
				this.removeSuperVisorState.creating = false;
				this.removeSuperVisorState.error = true;
				setTimeout(() => {
					this.removeSuperVisorState.error = false;
				}, 2000);
				console.log(err);
			});
		},
		deletevesselData() {
			console.log("deleting data");
			this.deletevesselState = true;
			axios.delete(this.$baseUrl + "/api/master/vessel/" + this.mastervessels[this.selectedToDelete].id, {
				"headers": {
					"Authorization": "Bearer " + localStorage.getItem("accessToken")
				}
			}).then((result) => {
				if (result.status == 200) {
					this.deletevesselState = false;
					this.vesselDeleted = true;

					setTimeout(() => {
						this.mastervessels.splice(this.selectedToDelete, 1);
						this.$bvModal.hide("modal-delete-vessel");
						this.vesselDeleted = false;
					}, 1000);
					console.log("yaya berhasil");
				}
			}).catch((err) => {
				//check if token fail
				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}
				this.deletevesselState = false;
				this.failDeletevessel = true;
				setTimeout(() => {
					this.failDeletevessel = false;
				}, 1000);
				console.log(err);
			});
		},
		deleteModalClose(mdl) {
			if (this.deletevesselState) {
				console.log("deleting");
				mdl.preventDefault();
			} else {
				console.log("closing");
				mdl.hide("modal-delete-vessel");
			}
		},
		editModalClose(mdl) {
			//step 2 edit
			this.$set(this.mastervessels, this.selectedIdforEdit, this.dataEdit);
			//step 3 edit
			this.dataEdit = Object.assign({}, null);
			if (this.updating) {
				console.log("updating");
				mdl.preventDefault();
			} else {
				console.log("closing");
				mdl.hide("modal-edit-user");
			}
		},
		detailModalClose(mdl) {
			if (this.deletevesselState) {
				console.log("deleting");
				mdl.preventDefault();
			} else {
				console.log("closing");
				mdl.hide("modal-detail-vessel");
			}
		},
		addNewSupervisor() {
			// console.log('updating data')
			// console.log(this.mastervessels[this.selectedIdforEdit])
			this.newSuperVisorState.creating = true;
			this.newSuperVisorState.error = false;
			axios.post(this.$baseUrl + "/api/master/vessel-supervisor", this.newSupervisor, {
				headers: {
					"Authorization": "Bearer " + localStorage.getItem("accessToken")
				}
			}).then((result) => {
				this.newSuperVisorState.creating = false;
				if (result.status = 200) {
					this.newSuperVisorState.success = true;
					this.newSupervisor = {};
					this.newsupervisorlabel = "";
					this.getVesselSupervisor();
					this.dataEdit = this.mastervessels[this.selectedIdforEdit];
					setTimeout(() => {
						this.newSuperVisorState.success = false;
						this.addSupervisorMenu = false;
					}, 2000);
				} else {
					this.newSuperVisorState.error = false;
				}
				// console.log(result)
			}).catch((err) => {
				//check if token fail
				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}
				this.newSuperVisorState.creating = false;
				this.newSuperVisorState.error = true;
				// console.log(err.response)
				setTimeout(() => {
					this.newSuperVisorState.error = false;
				}, 2000);
				console.log(err.response);
			});
		},
		updatevesselData() {
			// console.log('updating data')
			// console.log(this.mastervessels[this.selectedIdforEdit])
			this.updating = true;
			this.errorUpdate = false;
			axios.put(
				this.$baseUrl + "/api/master/vessel/" + this.mastervessels[this.selectedIdforEdit].id,
				this.mastervessels[this.selectedIdforEdit],
				{
					headers: {
						"Authorization": "Bearer " + localStorage.getItem("accessToken")
					}
				}
			).then((result) => {
				if (result.status = 200) {
					this.updating = false;
					this.updateSaved = true;
					this.getMastervessels();
					this.dataEdit = this.mastervessels[this.selectedIdforEdit];
					setTimeout(() => {
						this.updateSaved = false;
						this.$bvModal.hide("modal-edit-vessel");
					}, 1000);
				}
				// console.log(result)
			}).catch((err) => {
				//check if token fail
				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}
				this.updating = false;
				this.errorUpdate = true;
				// console.log(err.response)
				setTimeout(() => {
					this.errorUpdate = false;
				}, 1000);
				console.log(err.response);
			});
		},
		updatevesselMapsData(){
			this.updating = true;
			this.errorUpdate = false;
			axios.post(
				this.$baseUrl + "/api/master/vessel/updateMaps/" + this.mastervessels[this.selectedIdforEdit].id,
				this.coordinatesMaps,
				{
					headers: {
						"Authorization": "Bearer " + localStorage.getItem("accessToken")
					}
				}
			).then((result) => {
				if (result.status = 200) {
					this.updating = false;
					this.updateSaved = true;
					this.getMastervessels();
					this.dataEdit = this.mastervessels[this.selectedIdforEdit];
					setTimeout(() => {
						this.updateSaved = false;
						this.$bvModal.hide("modal-map-vessel");
					}, 1000);
				}
				// console.log(result)
			}).catch((err) => {
				//check if token fail
				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}
				this.updating = false;
				this.errorUpdate = true;
				// console.log(err.response)
				setTimeout(() => {
					this.errorUpdate = false;
				}, 1000);
				console.log(err.response);
			});
		},
		// statusTypeOptions: [
		// 	{label: "Aktif", value: "active"},
		// 	{label: "Tidak aktif", value: "inactive"}
		// ]
	}
};
</script>
<style>
button:focus {
	outline: 0;
}

.modal-header .close {
	padding: 0.5rem 1rem;
}

.sidebar .nav li .nav-link, body > .navbar-collapse .nav li .nav-link {
	margin: 5px;
}
</style>
<style scoped>


.card-body {
	background-color: #002060;
	border-radius: 1.25rem;
	color: #fff;
}

.card-body p {
	margin-bottom: 0;
}

.card {
	border: 1px solid rgba(0, 0, 0, 0);
	height: 200px;
	width: 230px;
}

h4, .h4 {
	margin: 0px 0 10px;
}

.btn {
	padding: 2px 6px;
}

::v-deep .modal-content {
	margin: -6rem auto;
}

.table > thead > tr > th, .table > tbody > tr > th, .table > tfoot > tr > th, .table > thead > tr > td, .table > tbody > tr > td, .table > tfoot > tr > td {
	width: 50%;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
	-webkit-appearance: none;
	margin: 0;
}

/* Firefox */
input[type=number] {
	-moz-appearance: textfield;
}
</style>


